import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c502a0a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "p-0 px-3 rounded-none max-w-[760px] pb-24"
}
const _hoisted_2 = { class: "bg-light-gray-100 flex flex-wrap justify-between items-center p-5 gap-3" }
const _hoisted_3 = { class: "flex flex-row justify-center items-center m-auto" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "uppercase text-[20px] font-black" }
const _hoisted_6 = { class: "p-5 pb-8 flex flex-col gap-5" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "text-3xl font-bold" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-4" }, "Worksona life quote", -1))
const _hoisted_10 = { class: "border-b-1 border-light-gray-300 pb-7" }
const _hoisted_11 = { class: "p-5 flex flex-col gap-5" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold" }, "Influential people", -1))
const _hoisted_13 = { class: "flex flex-row gap-5" }
const _hoisted_14 = {
  key: 0,
  class: "flex flex-col items-center justify-center gap-2"
}
const _hoisted_15 = ["src", "alt"]
const _hoisted_16 = { class: "p-5 flex flex-col gap-5" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-3xl font-bold" }, "Characteristics", -1))
const _hoisted_18 = { class: "flex flex-row flex-wrap gap-2" }
const _hoisted_19 = { class: "p-5 flex flex-col gap-5" }
const _hoisted_20 = { class: "flex flex-col gap-2" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-3xl font-bold" }, "Motivation", -1))
const _hoisted_22 = { class: "flex flex-col gap-2" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-3xl font-bold" }, "Fear", -1))
const _hoisted_24 = { class: "flex flex-col gap-2" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-3xl font-bold" }, "Problem Solving", -1))
const _hoisted_26 = { class: "flex flex-col gap-2" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-3xl font-bold" }, "Pitifalls", -1))
const _hoisted_28 = { class: "list-['😧'] px-5 flex flex-col gap-2" }
const _hoisted_29 = { class: "flex flex-col gap-5 mx-5 py-5 border-t-1 border-light-gray-300" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold" }, "Your dominant worksonas", -1))
const _hoisted_31 = {
  key: 0,
  class: "flex flex-row w-full gap-12 overflow-auto scroll"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col gap-4" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "font-bold" }, "What this means"),
  /*#__PURE__*/_createElementVNode("p", null, " An individual has several traits and characteristics that define their work persona. Your dominant worksonas mean that you are able to interchange your worksona depending on the situation you are in. ")
], -1))
const _hoisted_33 = { class: "flex flex-col gap-5 mx-5 py-5 border-t-1 border-light-gray-300" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold" }, "Your dormant worksona", -1))
const _hoisted_35 = {
  key: 0,
  class: "flex flex-row w-full gap-12 overflow-auto scroll"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col gap-4" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "font-bold" }, "What this means"),
  /*#__PURE__*/_createElementVNode("p", null, " Your dormant worksonas are traits and characteristics that you rarely or never use at all. It’s good to know these now so you can see your transformation as you go through different phases of your work life. ")
], -1))
const _hoisted_37 = {
  key: 1,
  class: "flex justify-center items-center mb-24 h-24"
}
const _hoisted_38 = {
  key: 0,
  href: "/survey/worksona"
}
const _hoisted_39 = { key: 1 }

import { onMounted, watch, ref, computed } from "vue"
  import { useUserStore } from "@/store/user"
  import { useResourcesStore, worksonaCodeType } from "@/store/resources"
  import { useRouter } from "vue-router"
  import { map, filter, first } from "lodash"
  import dateParser from "@/utils/dateParser"
  import { IonButton } from "@ionic/vue"
  import { toastController } from "@ionic/vue"
  import WorksonaSummary from "@/components/talent-profile/WorksonaSummary.vue"

  import explorerImage from "@/assets/images/worksona/icon/explorer.svg"
  import innocentImage from "@/assets/images/worksona/icon/innocent.svg"
  import innovatorImage from "@/assets/images/worksona/icon/innovator.svg"
  import inventorImage from "@/assets/images/worksona/icon/inventor.svg"
  import jesterImage from "@/assets/images/worksona/icon/jester.svg"
  import philosopherImage from "@/assets/images/worksona/icon/philosopher.svg"
  import realistImage from "@/assets/images/worksona/icon/realist.svg"
  import supporterImage from "@/assets/images/worksona/icon/supporter.svg"
  import sweetheartImage from "@/assets/images/worksona/icon/sweetheart.svg"
  import warriorImage from "@/assets/images/worksona/icon/warrior.svg"
  import rulerImage from "@/assets/images/worksona/icon/ruler.svg"
  import rebelImage from "@/assets/images/worksona/icon/rebel.svg"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'WorksonaContainer',
  setup(__props) {

  const userStore = useUserStore()
  const resourcesStore = useResourcesStore()
  const router = useRouter()
  const lastTake = computed(() => userStore.customerDetails.profile.worksona.last_take)
  const retakable = computed(() => dateParser.convertToLocalUTC(lastTake.value, "dd/MM/yyyy HH:mm:ss").getTime() <= new Date().getTime())
  const myWorksona = computed(() => userStore.userTalentProfile.user_id === userStore.customerDetails.profile.user_id)
  const hasEditButton = computed(() => userStore.userTalentProfile.user_id === userStore.customerDetails.profile.user_id)
  const dormant = ref<any[]>([])
  const dominant = ref<any[]>([])
  const worksonaIcon = {
    explorer: explorerImage,
    innocent: innocentImage,
    innovator: innovatorImage,
    inventor: inventorImage,
    jester: jesterImage,
    philosopher: philosopherImage,
    realist: realistImage,
    supporter: supporterImage,
    sweetheart: sweetheartImage,
    warrior: warriorImage,
    ruler: rulerImage,
    rebel: rebelImage,
  }

  /**
   * take worksona
   */
  const takeWorksona = async () => {
    if (retakable.value) window.location.href = "/survey/worksona"
    else {
      const toast = await toastController.create({
        message: "You can only take worksona every 90 days.",
        duration: 3000,
        position: "top",
        color: "light",
      })
      await toast.present()
    }
  }

  /**
   * get percentage
   * @param codename - archetype that need to get percentage
   * @return percentage of archtype
   */
  const getPercentage = (codename: string) => {
    const max = userStore.worksonaDetails.maxValue === 21 ? 21 : 20
    return ((userStore.customerDetails.profile.worksona[codename as string] / max) * 100).toFixed(0)
  }

  /**
   * init worksona details
   */
  const initDetails = async () => {
    if (userStore.worksonaDetails.dominant.length > 0) {
      const result = await map(userStore.worksonaDetails.dominant, async (codename: string) => {
        return await resourcesStore.retrieveWorksonaResult(codename, true)
      })
      dominant.value = (await Promise.all(result)) as any[]
    }
    if (userStore.worksonaDetails.dormant.length > 0) {
      const result = await map(userStore.worksonaDetails.dormant, async (codename: string) => {
        return await resourcesStore.retrieveWorksonaResult(codename, true)
      })
      dormant.value = (await Promise.all(result)) as any[]
    }
  }

  onMounted(() => {
    userStore.getWorksonaResult("public")
    if (userStore.worksonaDetails.dominant.length > 0) initDetails()
  })

  watch(
    () => userStore.worksonaDetails,
    () => {
      if (userStore.worksonaDetails.dominant.length > 0) initDetails()
    },
    { deep: true }
  )

return (_ctx: any,_cache: any) => {
  return (_unref(userStore).worksona !== '')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: worksonaIcon[_unref(resourcesStore).worksona.codename],
              alt: _unref(resourcesStore).worksona.archetype,
              class: "w-[80px] h-[80px] grayscale"
            }, null, 8, _hoisted_4),
            _createElementVNode("h2", _hoisted_5, _toDisplayString(_unref(resourcesStore).worksona.archetype), 1)
          ]),
          (_unref(myWorksona))
            ? (_openBlock(), _createBlock(_unref(IonButton), {
                key: 0,
                class: "m-auto",
                onClick: takeWorksona
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Take Worksona")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("img", {
            src: _unref(resourcesStore).worksona.image,
            alt: _unref(resourcesStore).worksona.name,
            class: "w-[20rem] rounded-[8px] h-[25rem] object-contain",
            style: _normalizeStyle({
          backgroundColor: _unref(resourcesStore).worksona.color,
        })
          }, null, 12, _hoisted_7),
          _createElementVNode("div", {
            class: "text-white px-10 py-5 rounded-[8px] w-fit-content relative mx-auto",
            style: _normalizeStyle({
          backgroundColor: _unref(resourcesStore).worksona.color,
        })
          }, [
            _createElementVNode("blockquote", _hoisted_8, _toDisplayString(_unref(resourcesStore).worksona.life_quote), 1),
            _hoisted_9,
            _createElementVNode("div", {
              class: "w-0 h-0 absolute -left-[9px] top-1",
              style: _normalizeStyle({ borderTop: '10px solid transparent', borderBottom: '10px solid transparent', borderRight: `10px solid ${_unref(resourcesStore).worksona.color}` })
            }, null, 4)
          ], 4),
          _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(resourcesStore).worksona.description), 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(resourcesStore).worksona.influential_figure.split(','), (figure) => {
              return (_openBlock(), _createElementBlock("div", { key: figure }, [
                (figure.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("img", {
                        src: `https://assets.workbean.co/worksona/influential-figure/${_unref(resourcesStore).worksona.codename}/${figure.trim()}.png`,
                        alt: figure,
                        class: "w-[80px]"
                      }, null, 8, _hoisted_15),
                      _createElementVNode("p", null, _toDisplayString(figure.trim()), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(resourcesStore).worksona.talents, (talent) => {
              return (_openBlock(), _createElementBlock("div", {
                key: talent,
                class: "text-white px-6 py-2 rounded-full font-bold",
                style: _normalizeStyle({
            backgroundColor: _unref(resourcesStore).worksona.color,
          })
              }, _toDisplayString(talent), 5))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", null, _toDisplayString(_unref(resourcesStore).worksona.motivation), 1)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("div", null, _toDisplayString(_unref(resourcesStore).worksona.fear), 1)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("div", null, _toDisplayString(_unref(resourcesStore).worksona.problem_solving_mechanism), 1)
          ]),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("ul", _hoisted_28, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(resourcesStore).worksona.pitfalls, (pitfall) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: pitfall,
                  class: "px-2"
                }, _toDisplayString(pitfall), 1))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _hoisted_30,
          (_unref(userStore).worksonaDetails.dominant.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(userStore).worksonaDetails.dominant, (codename) => {
                  return (_openBlock(), _createElementBlock("div", { key: codename }, [
                    (codename && codename.length)
                      ? (_openBlock(), _createBlock(WorksonaSummary, {
                          key: 0,
                          data: _unref(first)(_unref(filter)(dominant.value, (obj) => obj.codename == codename)),
                          percentage: getPercentage(codename),
                          class: "w-[100px]"
                        }, null, 8, ["data", "percentage"]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _hoisted_32
        ]),
        _createElementVNode("div", _hoisted_33, [
          _hoisted_34,
          (_unref(userStore).worksonaDetails.dormant.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(userStore).worksonaDetails.dormant, (codename) => {
                  return (_openBlock(), _createElementBlock("div", { key: codename }, [
                    (codename && codename.length)
                      ? (_openBlock(), _createBlock(WorksonaSummary, {
                          key: 0,
                          data: _unref(first)(_unref(filter)(dormant.value, (obj) => obj.codename == codename)),
                          percentage: getPercentage(codename),
                          class: "w-[100px]"
                        }, null, 8, ["data", "percentage"]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _hoisted_36
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_37, [
        (_unref(hasEditButton))
          ? (_openBlock(), _createElementBlock("a", _hoisted_38, [
              _createVNode(_unref(IonButton), null, {
                default: _withCtx(() => [
                  _createTextVNode("Take your Worksona now")
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock("p", _hoisted_39, "Nothing to see here."))
      ]))
}
}

})